module.exports = __webpack_public_path__ + "img/bannerBot.ec218070.png";